import { PageComponent } from '@frontend/pages/page.component';

export const pagesRoutes = {
  path: 'page/:slug',
  component: PageComponent
};